import { retailerContext } from './retailer-context'
import { advertContext } from './advert-context'
import { card } from './card'
import { advertCardFeatures } from './advert-card-features'
import { distance } from './distance'
import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { gridPosition, GridPosition } from './grid-position'
import { Entities } from '@at/track-core'
import { CURRENT_PAGE_ENTITY_VERSION } from '@at/consumer-web-snowplow'
import { CurrentPageEntityVersionType } from '@at/consumer-web-snowplow/lib/tracking-utils/types.utils'

export const getCommonComponentContexts = (trackingContext: TrackingContext): Entities => {
    const entities: Entities = []
    if (trackingContext.retailerContext?.id) {
        entities.push(retailerContext(trackingContext.retailerContext.id))
    }
    if (trackingContext.advertContext?.id) {
        entities.push(advertContext(trackingContext.advertContext))
    }
    if (trackingContext.card) {
        entities.push(card(trackingContext.card))
    }
    if (trackingContext.advertCardFeatures) {
        entities.push(advertCardFeatures(trackingContext.advertCardFeatures))
    }
    if (trackingContext.distance) {
        entities.push(distance(trackingContext.distance))
    }
    const gridPositionEntity = gridPosition(trackingContext.gridPosition)
    if (gridPositionEntity) {
        entities.push(gridPositionEntity)
    }
    return entities
}

export interface TrackingContext
    extends SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext {
    gridPosition: GridPosition | null
}

export const mockPageEntity: CurrentPageEntityVersionType = {
    SCHEMA_KEY: CURRENT_PAGE_ENTITY_VERSION,
    name: 'test-page',
    channel: 'cars',
}

export const removeMatchingEntities = (entities: Entities, entitiesToReplace: Entities): Entities => {
    const schemaKeysSet = new Set(entitiesToReplace.map((entity) => entity.SCHEMA_KEY))
    return entities.filter((entity) => !schemaKeysSet.has(entity.SCHEMA_KEY))
}
